import React from 'react';
import { Box } from '@abyss/web/ui/Box';
import { Outlet, useLocation } from 'react-router';
import { Brandmark } from '@abyss/web/ui/Brandmark';
import { GlobalStyles } from '../styles';

export const SharedLayout = () => {
  GlobalStyles();
  const location = useLocation();
  const isLoginRoute = location.pathname === '/login';

  if (isLoginRoute) {
    return (
      <Box height="100vh" width="100%" align="start">
        <Outlet />
      </Box>
    );
  }

  return (
    <Box color="$gray2" padding={25} align="start" height="100%" width="100%">
      <Brandmark
        brand="optum"
        size="$sm"
        affiliate="optum"
        variant="lockup"
        color="orange"
      />
      <Box
        color="$gray2"
        padding={40}
        align="center"
        height="100%"
        width="100%"
      >
        <Outlet />
      </Box>
    </Box>
  );
};
